import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { IconCheckMark } from '../components/Icons';

import {
  G00GLE_RECAPTCHA_API_KEY,
  BVOG_EMAIL_CONTACT_PAGE,
  BVOG_EMAIL_API_URL
} from '../constants';

const recaptchaRef = React.createRef();

class Form extends React.Component {
  state = {
    isSubmited: false,
    isCaptcha: false,
    email: '',
    firstname: '',
    lastname: '',
    message: ''
  };

  onSubmit = async event => {
    event.preventDefault();

    const { email, firstname, lastname, message } = this.state;
    const { subjectName, recipientEmail = BVOG_EMAIL_CONTACT_PAGE } = this.props;

    const currentRecaptcha = recaptchaRef.current;
    const URL = `${BVOG_EMAIL_API_URL}/api/v1/contact-form`;
    const Data = {
      recipientEmail: recipientEmail,
      subject: subjectName,
      data: [
        {
          email,
          firstname,
          lastname,
          message
        }
      ]
    };

    try {
      await fetch(URL, {
        method: 'POST',
        body: JSON.stringify(Data),
        headers: {
          'Content-Type': 'application/json'
        }
      });

      currentRecaptcha.reset(currentRecaptcha.getWidgetId());
      this.setState(
        {
          isSubmited: true,
          isCaptcha: false,
          email: '',
          firstname: '',
          lastname: '',
          message: ''
        },
        () => {
          setTimeout(() => {
            this.setState({ isSubmited: false });
          }, 5000);
        }
      );
    } catch (error) {
      console.error('Error:', error);
      this.setState({ isSubmited: false, isCaptcha: false });
    }
  };

  onChangeCaptcha = value => {
    this.setState({ isCaptcha: !!value });
  };

  handleChange = event => {
    const { name, value } = event.target;

    this.setState({ [name]: value });
  };

  render() {
    const { isSubmited, isCaptcha, email, firstname, lastname, message } = this.state;

    return (
      <form onSubmit={this.onSubmit} className="form-wrapper">
        <input
          className="input"
          type="email"
          name="email"
          value={email}
          onChange={this.handleChange}
          placeholder="E-Mail*"
          required
        />
        <input
          className="input"
          type="text"
          name="firstname"
          value={firstname}
          onChange={this.handleChange}
          placeholder="Vorname*"
          required
        />
        <input
          className="input"
          type="text"
          name="lastname"
          value={lastname}
          onChange={this.handleChange}
          placeholder="Nachname*"
          required
        />
        <textarea
          className="input"
          name="message"
          cols="30"
          rows="5"
          value={message}
          onChange={this.handleChange}
          placeholder="Nachricht*"
          required
        />

        <ReCAPTCHA
          className="mb-2"
          ref={recaptchaRef}
          sitekey={G00GLE_RECAPTCHA_API_KEY}
          onChange={this.onChangeCaptcha}
        />
        <button className="btn" disabled={!isCaptcha}>
          {isSubmited ? (
            <div className="d-flex align-items-center">
              <IconCheckMark />
              Gesendet
            </div>
          ) : (
            <div>Absenden</div>
          )}
        </button>
      </form>
    );
  }
}

export default Form;
